export default __webpack_public_path__ + "static/media/94844930-5c66-4c12-a670-93b048169dbe.2b02e51d.webp";